import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { type ChildRouteContext } from "@/root";

import ProfileForm from "@/modules/profile/user/components/ProfileForm";
import { fetchProfileQueryOptions } from "@/modules/profile/user/services";

export const Route = createFileRoute("/_panel/_profile/profile/$id")({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) =>
    ({
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Profile", { ns: "profile.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchProfileQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function Component() {
  const { id } = Route.useParams();

  return <ProfileForm id={id} />;
}
